angular.module('shared').directive('confirmBulkMessage', function() {
  return {
    restrict: 'E',
    template: require('templates/shared/confirm_bulk_message.html.slim'),
    scope: {
      bulkMessage: '=',
      externalPage: '=',
      visible: '='
    },
    controller: ["$scope", "$filter", "$stateParams", "$timeout", "ngTableParams", "MessageService", "DefaultReplyAddressService", "bulkMessageService", "ReactModal", function($scope, $filter, $stateParams, $timeout, ngTableParams, MessageService, DefaultReplyAddressService, bulkMessageService, ReactModal) {
      var checkAllRecipientsSelected, getDuplicateCount, getTotal, isContactUnsubscribed, toggleRecipients;
      $scope.gymId = $stateParams.gymId;
      $scope.allRecipientsSelected = true;
      getTotal = function() {
        var ref, ref1;
        return ((ref = $scope.bulkMessage) != null ? (ref1 = ref.recipientList) != null ? ref1.length : void 0 : void 0) || 0;
      };
      $scope.orderBy = {
        display_last_name: 'asc'
      };
      $scope.$on('$stateChangeStart', function(event, toState) {
        var ref;
        if ((ref = toState.data) != null ? ref.preserveBulkMessage : void 0) {
          return;
        }
        bulkMessageService.set({
          recipients: [],
          template: {
            reply_address: DefaultReplyAddressService.getDefaultEmail()
          }
        });
        $scope.recipients = [];
        return $scope.template = {
          reply_address: DefaultReplyAddressService.getDefaultEmail()
        };
      });
      $scope.tableParams = new ngTableParams({
        page: 1,
        count: 50
      }, {
        counts: [],
        total: getTotal(),
        getData: function($defer, params) {
          var orderKey, recipients, reverse;
          orderKey = _.keys($scope.orderBy)[0];
          reverse = $scope.orderBy[orderKey] === 'desc';
          recipients = $filter('orderBy')($scope.bulkMessage.groupedRecipients, orderKey, reverse);
          params.total(getTotal());
          return $defer.resolve(recipients.slice((params.page() - 1) * params.count(), params.page() * params.count()));
        }
      });
      $timeout(function() {
        return $scope.$watch('bulkMessage', function() {
          return $scope.tableParams.reload();
        }, true);
      });
      $scope.isEmail = function() {
        return $scope.bulkMessage.template.channel === 'email';
      };
      $scope.isSms = function() {
        return $scope.bulkMessage.template.channel === 'sms';
      };
      $scope.isPushNotification = function() {
        return $scope.bulkMessage.template.channel === 'push_notification';
      };
      $scope.pluralMessageType = function() {
        return bulkMessageService.pluralMessageType($scope.bulkMessage.template.channel, $scope.bulkMessage.recipientList);
      };
      $scope.displayNotNotifiableMessage = function() {
        return MessageService.message({
          title: 'Non-contactable contacts',
          message: ['For a push notification to be delivered successfully, a contact will need to have used the mobile app recently.', 'If a contact has not used the mobile app within the last 2 months, Clubworx is obliged to remove their device ID from our records. In this case, email or SMS messages may be a better choice.']
        });
      };
      $scope.notNotifiableCount = function() {
        var notNotifiableContacts;
        notNotifiableContacts = _.filter($scope.bulkMessage.groupedRecipients, function(item) {
          var ref;
          return (ref = item.push_notification_status) !== 'notifiable' && ref !== 'access_disabled';
        });
        return notNotifiableContacts.length;
      };
      checkAllRecipientsSelected = function() {
        return $scope.allRecipientsSelected = _.every($scope.bulkMessage.recipientList, function(recipient) {
          return recipient.selected || isContactUnsubscribed(recipient);
        });
      };
      $scope.toggleContact = function(contact) {
        $scope.bulkMessage.recipientList = $scope.bulkMessage.recipientList.map(function(item) {
          if (item.id === contact.id) {
            item.selected = !item.selected;
          }
          return item;
        });
        checkAllRecipientsSelected();
        return getDuplicateCount();
      };
      $scope.isContactSelected = function(contact) {
        var item;
        item = _.find($scope.bulkMessage.recipientList, function(i) {
          return contact.id === i.id;
        });
        return item != null ? item.selected : void 0;
      };
      toggleRecipients = function(recipients, value) {
        var channel;
        channel = $scope.bulkMessage.template.channel;
        return recipients.map(function(recipient) {
          var selectedEmail, selectedPushNotification, selectedSms;
          selectedSms = channel === 'sms' && !recipient.unsubscribed_from_sms && recipient.phone_number;
          selectedEmail = channel === 'email' && !recipient.unsubscribed_from_email && recipient.email;
          selectedPushNotification = channel === 'push_notification' && recipient.push_notification_status === 'notifiable';
          if (selectedSms || selectedEmail || selectedPushNotification) {
            recipient.selected = value;
          }
          return recipient;
        });
      };
      $scope.toggleRecipients = function() {
        $scope.allRecipientsSelected = !$scope.allRecipientsSelected;
        $scope.bulkMessage.recipientList = toggleRecipients($scope.bulkMessage.recipientList, $scope.allRecipientsSelected);
        return getDuplicateCount();
      };
      $scope.showPageRange = function() {
        var prevPagesCount;
        prevPagesCount = ($scope.tableParams.page() - 1) * $scope.tableParams.count();
        return `${prevPagesCount + 1} - ${prevPagesCount + $scope.tableParams.data.length}`;
      };
      $scope.toggleSorting = function(column) {
        var order, params;
        params = {};
        order = $scope.orderBy[column] === 'asc' ? 'desc' : 'asc';
        params[column] = order;
        $scope.orderBy = params;
        return $scope.tableParams.reload();
      };
      $scope.isSortedBy = function(column, order) {
        return $scope.orderBy[column] === order;
      };
      $scope.emailNotAccepted = function(recipient) {
        return recipient.email_status === 'email_not_accepted';
      };
      $scope.smsNotAccepted = function(recipient) {
        return recipient.sms_status === 'sms_not_accepted';
      };
      getDuplicateCount = function() {
        return $scope.duplicateCount = bulkMessageService.getDuplicateCount($scope.bulkMessage.recipientList, $scope.bulkMessage.template.channel);
      };
      $scope.$watch('visible', function() {
        return getDuplicateCount();
      });
      $scope.manageDuplicateRecipients = function() {
        var modalInstance;
        modalInstance = ReactModal.open({
          component: 'ManageDuplicateRecipientsModal',
          drawer: true,
          props: {
            recipients: bulkMessageService.getDuplicatesGroups($scope.bulkMessage.recipientList, {
              type: $scope.bulkMessage.template.channel,
              includeDeselected: true
            }),
            channel: $scope.bulkMessage.template.channel
          }
        });
        return modalInstance.then(function() {
          getDuplicateCount();
          return checkAllRecipientsSelected();
        });
      };
      return $scope.isContactUnsubscribed = isContactUnsubscribed = function(contact) {
        var ref;
        if ($scope.isEmail()) {
          return contact.unsubscribed_from_email || !contact.email;
        }
        if ($scope.isSms()) {
          return contact.unsubscribed_from_sms || !contact.phone_number;
        }
        if ($scope.isPushNotification()) {
          return (ref = contact.push_notification_status) !== 'notifiable' && ref !== 'access_disabled';
        }
      };
    }]
  };
});
